import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "reactstrap";
import { ICode } from "../../model/code.model";

interface IProps {
  validation: ICode;
  handleClose: () => void;
}

export const BodyCodeValidation = (props: IProps) => {
  return (
    <>
      <Modal.Header className="header-modal-document flex-column">
        <div className="d-flex justify-content-end w-100 mb-4">
          <FontAwesomeIcon
            className="text-dark cursor-pointer"
            icon={faTimes}
            onClick={props.handleClose}
          />
        </div>
        <div className="header-modal-already-postulate fw-bold fs-5 text-dark">
          Se detectó un candidato con el mismo DNI
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body-generic modal-body-already-postulate text-center">
        <p>
          Para continuar por favor ingrese el código que
          <br /> enviamos al correo {props.validation.mail || ""}
        </p>
      </Modal.Body>
    </>
  );
};
